
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owner/earnings_and_payouts",
      function () {
        return require("private-next-pages/owner/earnings_and_payouts.js");
      }
    ]);
  